<template>
  <div class="col-xs-10 col-sm-10 grid_div" id="grid_right_div">
    <!--<div id="flushBtn" @click="loadIndexStuData()"></div>-->
    <div id="contentDiv">

      <div id="newTaskMsgDiv" class="showMsgDiv">
        <div class="divHead">
          <div class="divHead_title">
            <div class="num_tip" :class="{tip_need: newTaskNum != ''}">{{newTaskNum}}</div>最新任务消息
          </div>
          <span @click="changeMenuClass('/task_stu')">
            <router-link to="/task_stu">更多&gt;&gt;</router-link>
          </span>
        </div>
        <div class="divBody">
          <table class="table tabShow">
            <tbody>
            <tr v-for="(task, index) in newTaskList" :key="index">
              <td style="width: 0%;"><div class="noRead_tip" :class="{tip_need: task.status == 0}"></div></td>
              <td class="tabTd_content_ellipsis tabTd_content_one" :title="task.content">
                {{task.content}}
                <span>提交截止日期：{{task.submitTime}}</span>
              </td>
              <td class="tabTd_content_ellipsis tabTd_time_one" :title="task.createTime">{{task.createTime}}</td>
              <td class="tabTd_btn_one">
                <button type="button" class="btn btn-default" @click="saveDataIntoStorage()">去查看</button>
                <button type="button" class="btn btn-default" v-if="task.status == 0" @click="ignoreTask(task.id)">忽略</button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div id="homeworkUploadDiv" class="showMsgDiv">
        <div class="divHead">
          <div class="divHead_title">
            <div class="num_tip"></div>作业上传记录
          </div>
          <span @click="changeMenuClass('/homeworkManage_stu')">
            <router-link to="/homeworkManage_stu">更多&gt;&gt;</router-link>
          </span>
        </div>
        <div class="divBody">
          <table class="table tabShow homework_tab">
            <thead>
              <tr>
                <th>作业类别</th>
                <th>作业名称</th>
                <th width="15%">作业要求</th>
                <th width="15%">附件</th>
                <th width="15%">我上传的</th>
                <th>截止日期</th>
                <th>上传日期</th>
                <th width="8%">操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(home, index) in homeWorkList" :key="index">
                <td>{{home.type}}</td>
                <td>{{home.name}}</td>
                <td class="tabTd_content_ellipsis" :title="home.summary">{{home.summary}}</td>
                <td class="tabTd_content_ellipsis" :title="home.fileName">
                  <a @click="openFileModal(home.filePath)">
                    {{home.fileName}}
                  </a>
                </td>
                <td class="tabTd_content_ellipsis" :title="home.sfileName">
                  <a @click="openFileModal(home.sfilePath)">
                    {{home.sfileName}}
                  </a>
                </td>
                <td>{{home.deadline}}</td>
                <td>{{home.suploadTime}}</td>
                <td>
                  <div class="uploadBtn" data-toggle="modal" data-target="#myModal"
                       :class="{displayNone: checkDate(home.deadline)}"
                       @click="homeWorkId=home.id;putHomeworkIdIntoUpload()"></div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!--文档显示-->
      <div class="modal fade" id="myModal_showFile" tabindex="-1" role="dialog" aria-labelledby="myModalLabel_showFile" aria-hidden="true" data-backdrop='static'>
        <div class="modal-dialog modal-dialog-look">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                &times;
              </button>
              <h4 class="modal-title" id="myModalLabel_showFile">
                文档预览
              </h4>
            </div>
            <div class="modal-body modal-body-look">
              <iframe :src="fileSrc" width="100%" height="700px"></iframe>
            </div>
          </div>
        </div>
      </div>

      <!-- 模态框（Modal） -->
      <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" data-backdrop='static'>
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                &times;
              </button>
              <h4 class="modal-title" id="myModalLabel">
                上传作业
              </h4>
            </div>
            <div class="modal-body">
              <!--上传-->
              <uploader :options="upload.options" :file-status-text="upload.statusText" class="uploader-example" ref="uploader">
                <uploader-unsupport></uploader-unsupport>
                <uploader-drop>
                  <p>拖拽作业文件至此处</p>
                  <uploader-btn :attrs="upload.attrs.file">选择文件</uploader-btn>
                </uploader-drop>
                <uploader-list></uploader-list>
              </uploader>
            </div>
            <!--<div class="modal-footer">
              <button type="button" class="btn btn-default btn_save" @click="saveUpload()">
                保存
              </button>
              <button type="button" class="btn btn-default btn_cancel" data-dismiss="modal">
                取消
              </button>
            </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import {schoolAxios} from "../main";

  import {getContentSize} from './mainView';

  import mainViewVue from './mainView';

  export default {
    name: "indexStu",
    data() {
      return {
        //任务
        newTaskList: [],
        newTaskNum: '',

        homeWorkId: '',
        //作业
        homeWorkList: [],

        //文档
        fileSrc: '',

        //上传
        upload: {
          uploader: null,
          options: {
            target: this.$store.state.serviceBase + 'studentSchoolwork/sswUpload.action',
            method: 'post',
            headers: {
              'Authorization': this.$store.state.token_type + " " + this.$store.state.access_token
            },
            query: {
              //studentId: this.$store.state.studentId
            },
            simultaneousUploads: 1,//同时上传数
            testChunks: false,
            chunkSize: 10*1024*1024*1024,//分片大小：10G
            singleFile: true,
          },
          attrs: {
            file: {
              accept: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword,application/pdf'
            },
            /*image: {
              accept: 'image/!*'
            },
            video: {
              accept: 'video/!*'
            },*/
          },
          statusText: {
            success: '成功了',
            error: '出错了',
            uploading: '上传中',
            paused: '暂停中',
            waiting: '等待中',
          },
        },
      }
    },
    filters: {

    },
    created: function () {

    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();

        //绑定加载关闭模态框时的事件
        this_.closeModal();

        //获得上传组件对象
        this_.upload.uploader = this_.$refs.uploader.uploader;
        //上传组件绑定事件
        this_.loadUpload();

        this_.loadIndexStuData();
      });
    },
    methods: {
      /**
       * 初始加载数据
       */
      loadIndexStuData(){
        let this_ = this;
        axios.all([
          schoolAxios({
            method: 'get',
            url: 'tasks/findList',
            params: {}
          }),
          schoolAxios({
            method: 'get',
            url: 'schoolwork/findHomeWorkListByStudent',
            params: {}
          }),
        ]).then(
          axios.spread(function (taskResp, homeResp) {
            //最新任务消息
            let taskData = taskResp.data;
            if(taskData.success){
              this_.newTaskList = taskData.list;
              this_.loadNewTaskNum();
            }

            //作业
            let homeworkData = homeResp.data;
            if(homeworkData.success){
              this_.homeWorkList = homeworkData.list;
            }
          })
        );
      },

      checkDate(date){
        let this_ = this;
        let date_now = new Date();
        date_now = date_now.getFullYear()+"-"+(date_now.getMonth() + 1)+"-"+date_now.getDate();
        date_now = new Date(date_now);
        let date_my = new Date(date);
        if(date_now <= date_my){
          return false;
        }
        return true;
      },

      /**
       * 加载最新任务条数
       */
      loadNewTaskNum(){
        let this_ = this;
        schoolAxios({
          method: 'get',
          url: 'tasks/getCountBy',
          params: {}
        }).then(function (resp) {
          let data = resp.data;
          if(data.success){
            this_.newTaskNum = data.data!=0?data.data:'';
          }
        })
      },

      /**
       * 添加参数
       */
      putHomeworkIdIntoUpload(){
        let this_ = this;
        this_.upload.options.query.schoolworkId = this_.homeWorkId;
        this_.upload.options.query.studentId = this_.$store.state.studentId;
      },

      /**
       * 重载任务数据
       */
      reloadTasksMsg(){
        let this_ = this;
        schoolAxios({
          method: 'get',
          url: 'tasks/findList',
          params: {}
        }).then(function (resp) {
          let data = resp.data;
          if(data.success){
            this_.newTaskList = data.list;
            this_.loadNewTaskNum();
          }
        })
      },
      /**
       * 任务忽略
       */
      ignoreTask(id){
        let this_ = this;
        schoolAxios({
          method: 'put',
          url: 'tasks/edit/'+id,
          params: {}
        }).then(function (resp) {
          let data = resp.data;
          if(data.success){
            this_.reloadTasksMsg();
          }else{
            "操作失败".showMessage();
          }
        })
      },

      /**
       * 跳转路由保存数据
       */
      saveDataIntoStorage(){
        let this_ = this;
        //路由跳转
        this_.$router.push({
          name: 'HomeworkManageStu',
        });
      },

      /**
       * 打开文件模态框
       */
      openFileModal(filePath) {
        let this_ = this;
        let data = filePath.substring(0, 11);
        let fileId = filePath.substring(11, filePath.indexOf('.'));
        this_.fileSrc = this_.$store.state.serviceBase + "resources/" + data + fileId + "_file/" + fileId + ".html";
        $("#myModal_showFile").modal("show");
      },
      /**
       * 关闭模态框监听
       */
      closeModal() {
        let this_ = this;
        $("#myModal").on('hide.bs.modal', function () {
          this_.upload.uploader.cancel();
        });
      },
      /**
       * 重载作业数据
       */
      reloadHomeworkManageStuData(){
        let this_ = this;
        schoolAxios({
          method: 'get',
          url: 'schoolwork/findHomeWorkListByStudent',
          params: {}
        }).then(function (homeResp) {
          //作业
          let homeworkData = homeResp.data;
          if(homeworkData.success){
            this_.homeWorkList = homeworkData.list;
          }
        })
      },
      /**
       * 上传加载
       */
      loadUpload(){
        let this_ = this;
        this_.upload.uploader.on('fileAdded', function (file, event) {
          if(this_.upload.attrs.file.accept.indexOf(file.fileType)==-1){
            (file.name+"不是所需格式文件，请重新选择正确的格式文件上传").showMessage();
            return false;
          }
        })
        this_.upload.uploader.on('fileSuccess', function (rootFile, file, message, chunk) {
          if(message){
            let message_ = JSON.parse(message);
            if(message_.success){
              message_.message.showMessage();
              this_.reloadHomeworkManageStuData();
              $("#myModal").modal("hide");
              this_.upload.uploader.cancel();
            }else {
              message_.message.showMessage();
            }
          }
        })
        this_.upload.uploader.on('fileComplete', function (rootFile) {
          //console.info(rootFile);
        })
        this_.upload.uploader.on('fileError', function (rootFile, file, message) {
          (file.name+"上传失败").showMessage();
        })
      },
      /**
       * 手动改变菜单样式
       * @param path
       */
      changeMenuClass(path){
        let this_ = this;
        mainViewVue.methods.changeMenuClass(path);
      }
    }
  }
</script>

<style scoped>
  @import '../assets/css/plugins.css';
  @import "../assets/css/publicStyle.css";
  @import "../assets/css/indexStu.css";

  .displayNone {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/indexStu.vue